import { UseDataQueryKey } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { useNetworkContext } from '../../../modules/offline/contexts/network/network.context';
import { formatOrderProductGridDTO } from '../../../modules/orders/products/helpers/orderProductGrid.formatter';
import { ProductAvailabilityGridDTO } from '../../../modules/products/details/productDetails.types';
import { getFindProductGridKey } from './product-grid.keys';
import { getProductGridRepository } from './product-grid.repository';
import { FindProductGridOutput, UseFindProductGridProps } from './product-grid.types';
import { getParamsWithPriceTable } from './product-grid.utils';

export const useFindProductGrid = (params: UseFindProductGridProps) => {
  const { isForcingOfflineMode } = useNetworkContext();

  const gridQueryKey: UseDataQueryKey = getFindProductGridKey(params);

  const gridQueryFn = async () => {
    const formattedParams = await getParamsWithPriceTable(params);

    const response = await getProductGridRepository(params.isOfflineMode).findProductGrid(
      formattedParams,
    );
    if (!response.ok || !response.data) {
      return null;
    }
    const productAvailability: ProductAvailabilityGridDTO = response.data[0];
    const data: FindProductGridOutput = {
      grid: formatOrderProductGridDTO({ productAvailability }) || [],
      suggestedGrid: response.data[0].suggestedSkus || [],
      suggestedPacks: response.data[0].suggestedPacks || [],
      hasValidPacks: response.data[0].hasValidPacks || false,
      selectedPacks: response.data[0].orderProductPack || [],
    };
    try {
      params.callback?.();
    } catch (error) {
      console.error('error executing product grid callback:', error);
    }
    return data;
  };

  const dataQuery = useDataQuery<FindProductGridOutput | null>(
    {
      queryKey: gridQueryKey,
      queryFn: gridQueryFn,
      refetchOnMount: false,
    },
    {
      enabled: params.enabled ?? true,
      networkMode: isForcingOfflineMode ? 'always' : undefined,
    },
  );

  return dataQuery;
};
